import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { updateStepData } from '../../Store/Actions/Partner';

import { useMediaQuery } from 'react-responsive';

import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { FileUpload } from 'primereact/fileupload';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';

import Grid from '@mui/material/Grid';

import {
  maskPhone,
  validateSingleField
} from '../../Components/Utils'


const socialOptions = [
  { label: 'Facebook', value: 'facebook' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'TikTok', value: 'tiktok' }
];

const RegisterStep4 = (props) => {

  const { 
    stepIndex, 
    stepData, 
    stepDataAll,
    updateStepData,
    stepValidations,
    setAlert, 
    setAlertTitle, 
    setAlertBody,    
  } = props;
  
  //console.log('stepDataAll STEP 4----------->'+JSON.stringify(stepDataAll,null,2));

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const toast = useRef(null);
  const fileInputRef = useRef(null);
  const formDataRef = useRef({});
  
  const [formFields, setFormFields] = useState({
    website: stepData?.website || '',
    socialLinks: stepData?.socialLinks || [{ link: '', type: '' }],
    additionalPhones: stepData?.additionalPhones || [''],
    additionalEmails: stepData?.additionalEmails || [''],
    logoFile: stepData?.logoFile || null,
    logoFileName: stepData?.logoFileName || ''
  });
  
  const handleFieldChange = (field, value) => {
    setFormFields(prev => {
      const updated = { ...prev, [field]: value };
      return updated;
    });
    formDataRef.current[field] = value;
  };

  const handleBlur = () => {
    updateStepData(stepIndex, { ...formDataRef.current });
  };
  
  const handleSocialLinkInputChange = (e, index) => {
    const updated = [...formFields.socialLinks];
    updated[index].link = e.target.value;
    handleFieldChange('socialLinks', updated);
  };

  const handleSocialTypeChange = (e, index) => {
    const updated = [...formFields.socialLinks];
    updated[index].type = e.value;
    handleFieldChange('socialLinks', updated);
  };

  const handlePhoneChange = (e, index) => {
    const value = maskPhone(e.target.value);
    const updated = [...formFields.additionalPhones];
    updated[index] = value;
    handleFieldChange('additionalPhones', updated);
  };

  const handleEmailChange = (e, index) => {
    const value = e.target.value;
    const updated = [...formFields.additionalEmails];
    updated[index] = value;
    handleFieldChange('additionalEmails', updated);
  };

  const handleAddSocialLink = () => {
    handleFieldChange('socialLinks', [...formFields.socialLinks, { link: '', type: '' }]);
  };

  const handleRemoveSocialLink = (index) => {
    const updated = [...formFields.socialLinks];
    updated.splice(index, 1);
    handleFieldChange('socialLinks', updated);
  };

  const handleUploadLogoInput = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
  
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      toast.current?.show({
        severity: 'error',
        summary: 'Erro',
        detail: 'Tipo de arquivo inválido. Somente JPEG, JPG ou PNG são permitidos.',
        life: 5000
      });
      return;
    }
  
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
  
    img.onload = () => {
      if (img.width < 120 || img.height < 120) {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: 'A imagem deve ter no mínimo 120x120 pixels.',
          life: 5000
        });
        return;
      }
  
      // Atualiza formFields corretamente
      handleFieldChange('logoFile', file);
      handleFieldChange('logoFileName', file.name);
      updateStepData(stepIndex, { 
        logoFile: file, 
        logoFileName: file.name 
      });
  
      toast.current?.show({
        severity: 'success',
        summary: 'Logo enviada',
        detail: `Arquivo "${file.name}" salvo com sucesso.`,
        life: 4000
      });
    };
  
    img.onerror = () => {
      toast.current?.show({
        severity: 'error',
        summary: 'Erro ao carregar imagem',
        detail: 'Não foi possível validar a imagem enviada.',
        life: 5000
      });
    };
  
    img.src = objectUrl;
  };
  
  const handleRemoveLogo = () => {
    handleFieldChange('logoFile', null);
    handleFieldChange('logoFileName', '');
    updateStepData(stepIndex, { logoFile: null, logoFileName: '' });
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <div style={{ width: '100%' }}>
      <Panel header="Links e mídias">

        <Grid container spacing={4} className={isMobile ? "mobileMasterGrid" : ""} >
          <Grid item xs={12} className={isMobile ? "gridChild" : ""}>
            <div className="formControl w100 tAlignL">
              <label htmlFor="website">Website</label>
              <InputText
                id="website"
                tabIndex={1} 
                className="w100"
                value={formFields.website}
                onChange={(e) => handleFieldChange('website', e.target.value)}
                onBlur={() => {
                  handleBlur();
                  const error = validateSingleField(stepValidations, 'website', formFields.website);
                  if (error) {
                    setAlert(true);
                    setAlertTitle('Website digitado é inválido');
                    setAlertBody(error);
                  }
                }}
              />
            </div>
          </Grid>

          {formFields.socialLinks.map((social, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12} className={isMobile ? "gridChild" : ""}>
                <div className="formControl formSocialMedia w100 tAlignL" style={{ position: 'relative' }}>
                  
                  <div className="flex-row align-items-center justify-between" style={{marginBottom: '0.5rem'}}>
                    <label style={{marginBottom:"0"}}>Rede social {index + 1}</label>
                    {index > 0 && (
                    <Button
                      icon="pi pi-times"
                      text
                      style={{color:"#C53F84"}}
                      label="Remover"
                      severity="danger"
                      onClick={() => handleRemoveSocialLink(index)}
                    />
                  )}    
                  {index == 0 && (
                    <div style={{height:"39px"}}>&nbsp;</div>
                  )}                                     
                </div>

                  <div className="flex-row align-items-center justify-content-between">
                    <InputText
                      id={`socialLink${index}`}
                      tabIndex={2 + index} 
                      className="w100"
                      value={social.link}
                      onChange={(e) => handleSocialLinkInputChange(e, index)}
                      onBlur={handleBlur}
                    />
                    <Dropdown
                      value={social.type}
                      tabIndex={3 + index} 
                      options={socialOptions}
                      onChange={(e) => handleSocialTypeChange(e, index)}
                      onSelect={handleBlur}
                      className="socialMediaDropdown"
                      style={{top:isMobile ? "49px" : "inherit"}}
                      placeholder="Selecione"
                    />      
                </div>                  

                </div>
              </Grid>
            </React.Fragment>
          ))}
          <div className="formControl w100 tAlignL" style={{ marginTop: '0.5rem' }}>
            <Button
              label="Adicionar outra rede social"
              icon="pi pi-plus"
              style={{ color: "#C53F84" }}
              text
              disabled={
                !formFields.socialLinks[formFields.socialLinks.length - 1]?.link?.trim().length > 0 ||
                !formFields.socialLinks[formFields.socialLinks.length - 1]?.type?.trim().length > 0
              }
              onClick={handleAddSocialLink}
            />
          </div>
        
          {formFields.additionalPhones.map((phone, index) => (
            <Grid item xs={12} key={`phone-${index}`} className={isMobile ? "gridChild" : ""}>
              <div className="formControl w100 tAlignL">
                
                <div className="flex-row align-items-center justify-between" style={{marginBottom: '0.5rem'}}>
                    <label style={{marginBottom:"0"}}>Telefone adicional {index + 1}</label>
                    {index > 0 && (
                    <Button
                      icon="pi pi-times"
                      text
                      style={{color:"#C53F84"}}
                      label="Remover"
                      severity="danger"
                      onClick={() => {
                        const updated = [...formFields.additionalPhones];
                        updated.splice(index, 1);
                        handleFieldChange('additionalPhones', updated);
                      }}
                    />
                  )}                   
                </div>

                <div className="flex-row align-items-center justify-content-between">
                  <InputText
                    value={phone}
                    tabIndex={4 + index} 
                    onChange={(e) => handlePhoneChange(e, index)}
                    onBlur={() => {
                      handleBlur();
                      const error = validateSingleField(stepValidations, 'additionalPhones', formFields.additionalPhones[index]);
                      if (error) {
                        setAlert(true);
                        setAlertTitle('Telefone digitado é inválido');
                        setAlertBody(error);
                      }
                    }}
                    className="w100"
                  />
                </div>
              </div>
            </Grid>
          ))}
          <div className="formControl w100 tAlignL" style={{ marginTop: '0.5rem' }}>
              <Button
                label="Adicionar outro telefone"
                icon="pi pi-plus"
                style={{color:"#C53F84"}}
                text
                disabled={!formFields.additionalPhones[formFields.additionalPhones.length - 1].trim().length > 0}
                onClick={() =>
                  handleFieldChange('additionalPhones', [...formFields.additionalPhones, ''])
                }
              />
          </div>
          

          {formFields.additionalEmails.map((email, index) => (
            <Grid item xs={12} key={`email-${index}`} className={isMobile ? "gridChild" : ""}>
              <div className="formControl w100 tAlignL">
                
                <div className="flex-row align-items-center justify-between" style={{marginBottom: '0.5rem'}}>
                    <label style={{marginBottom:"0"}}>E-mail adicional {index + 1}</label>
                    {index > 0 && (
                      <Button
                        icon="pi pi-times"
                        label="Remover"
                        text
                        severity="danger"
                        onClick={() => {
                          const updated = [...formFields.additionalEmails];
                          updated.splice(index, 1);
                          handleFieldChange('additionalEmails', updated);
                        }}
                      />
                    )}                    
                </div>
                
                <div className="flex-row align-items-center justify-content-between">
                    <InputText
                      value={email}
                      onChange={(e) => handleEmailChange(e, index)}
                      onBlur={() => {
                        handleBlur();
                        const error = validateSingleField(stepValidations, 'additionalEmails', formFields.additionalEmails[index]);
                        if (error) {
                          setAlert(true);
                          setAlertTitle('Email digitado é inválido');
                          setAlertBody(error);
                        }
                      }}
                      className="w100"
                    />
                </div>
              </div>
            </Grid>
          ))}
          <div className="formControl w100 tAlignL" style={{ marginTop: '0.5rem' }}>
            <Button
              label="Adicionar outro e-mail"
              style={{color:"#C53F84"}}
              icon="pi pi-plus"
              text
              disabled={!formFields.additionalEmails[formFields.additionalEmails.length - 1].trim().length > 0}
              onClick={() =>
                handleFieldChange('additionalEmails', [...formFields.additionalEmails, ''])
              }
            />
          </div>

        </Grid>
      </Panel>

      <Panel header="Upload da logo" className="logoUploadBlock" style={{ marginTop: "1.5rem" }}>
        <Toast ref={toast} position="bottom-center"  />
        <div className="logoUploadArea">
          <div className="title">Selecione ou arraste um arquivo JPEG, JPG ou PNG com até 5MB.</div>
          <div className="buttonWrapper">
            <input
              type="file"
              tabIndex={5} 
              ref={fileInputRef}
              accept="image/jpeg,image/jpg,image/png"
              onChange={handleUploadLogoInput}
              style={{ display: 'none' }}
            />
            <Button
              label="Selecionar arquivo"
              outlined
              icon="pi pi-upload"
              className="fileUpload"
              onClick={() => fileInputRef.current?.click()}
            />              
          </div>
        </div>
        <small className="tAlignL w100 dBlock" style={{ marginTop: "0.5rem" }}>
          Tamanho mínimo da imagem: 120x120 pixels.
        </small>

        {formFields.logoFile && (
          <div className="logoUploadImage" style={{ marginTop: "2rem" }}>
            <Card className="logotypeUploadCard" title="Logo enviada" style={{ width: '250px' }}>
              <img
                src={URL.createObjectURL(formFields.logoFile)}
                alt="Logo Preview"
                style={{ width: '100%', maxHeight:'220px', borderRadius: '8px' }}
              />
              <Button
                label="Remover logo"
                icon="pi pi-times"
                severity="danger"
                text
                onClick={handleRemoveLogo}
                style={{ marginTop: '1rem' }}
              />
            </Card>
          </div>
        )}

      </Panel>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  stepData: state.partnerReducer.stepData[ownProps.stepIndex],
  stepDataAll: state.partnerReducer.stepData,
});

const mapDispatchToProps = {
  updateStepData
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterStep4);
